export default __webpack_public_path__ + "assets/images/0b2590b8c0960b989aae74be15d594c7.svg";